import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconHistory: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconHistory" {...props}>
    <svg width="18" height="17" viewBox="0 0 18 17" fill="currentColor">
      <path
        d="M15.613 13.904C17.204 12.312 18 10.393 18 8.146s-.796-4.167-2.387-5.758C14.02.796 12.1 0 9.854 0 7.748 0 5.91.714 4.342 2.142 2.797 3.57 1.932 5.325 1.744 7.408l-.808-1.58c-.164-.28-.35-.35-.561-.21l-.14.035C0 5.817-.06 6.016.058 6.25l1.404 2.668v.035l.105.176a.314.314 0 0 0 .21.175.306.306 0 0 0 .317-.035l.175-.105h.036l2.598-1.65c.234-.164.28-.363.14-.597l-.105-.14c-.117-.211-.304-.235-.562-.07l-1.545.982.035-.035c.117-1.826.843-3.37 2.177-4.634 1.358-1.264 2.961-1.896 4.81-1.896 1.943 0 3.593.678 4.95 2.036 1.382 1.381 2.072 3.031 2.072 4.95 0 1.943-.69 3.605-2.071 4.986-1.358 1.381-3.008 2.072-4.95 2.072a6.968 6.968 0 0 1-3.16-.738 7.186 7.186 0 0 1-2.458-2.071c-.234-.304-.504-.34-.808-.105-.28.234-.316.491-.105.772.796 1.053 1.755 1.86 2.879 2.423a8.194 8.194 0 0 0 3.651.842c2.247 0 4.167-.796 5.759-2.387Z"
        fill="currentColor"
      />
      <path
        d="M10.123 3.562v5.407l2.669 2.633a.653.653 0 0 1 0 .808c-.28.257-.55.257-.808 0L9.211 9.6h-.035A.575.575 0 0 1 9 9.18V3.561c0-.164.047-.293.14-.386A.575.575 0 0 1 9.562 3c.164 0 .292.059.386.176a.468.468 0 0 1 .175.386Z"
        fill="currentColor"
      />
    </svg>
  </IconSVG>
)
